import Script from 'next/script';
import { useEffect } from 'react';

import { isDev, isSSR } from '@/utility/isSSR';

interface OneTrustProps {
  domainScript?: string;
}

export const OneTrust = ({ domainScript }: OneTrustProps) => {
  useEffect(() => {
    // Skip execution if the code is running on the server
    if (isSSR() || isDev()) return;

    // Check for automated test environments at runtime
    const isAutomatedBrowser =
      !!window.navigator.webdriver ||
      !!(window as any).Cypress ||
      !!(window as any).__playwright ||
      !!(window as any).__puppeteer;

    if (isAutomatedBrowser) {
      // Function to hide the banner
      const hideBanner = () => {
        const cookiesBanner = document.getElementById('onetrust-banner-sdk');
        if (cookiesBanner && cookiesBanner.style.display !== 'none') {
          cookiesBanner.style.display = 'none';
        }
      };

      // Try to hide immediately in case banner already exists
      hideBanner();

      // Set up observer to continuously hide banner whenever it appears
      const observer = new MutationObserver(() => {
        hideBanner();
      });

      // Observe the DOM for any changes - keep observing indefinitely
      observer.observe(document.body, { childList: true, subtree: true });

      // Cleanup function to disconnect observer
      return () => observer.disconnect();
    }
  }, []);

  if (isDev()) {
    return null;
  }

  return (
    <Script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      data-domain-script={domainScript || process.env.oneTrustDomainScript}
      strategy="beforeInteractive"
    />
  );
};
